import { createStore } from 'vuex'

// Game data. Real titles only — Idle Cat Hotel Tycoon is live; Idle Magician RPG
// is in development (coming soon). Screenshots are injected once the studio
// provides them; until then GameCard falls back to the app art.
//
// Item shape:
//   { id, name, oneLiner, status: 'live' | 'coming-soon',
//     art, screenshots: [{ src, alt }],
//     platforms: { android: { url }, ios: { url } } }   // url null until available

const GAMES = [
  {
    id: 'idle-cat-hotel',
    name: 'Cozy Cat Hotel',
    oneLiner: 'Build a cozy hotel for adorable cats.',
    status: 'live',
    art: require('@/assets/idlecathotelAppIcon.png'),
    screenshots: [],
    platforms: {
      android: { url: 'https://play.google.com/store/apps/details?id=com.luckypunch.idlecathotel' },
      ios: { url: 'https://apps.apple.com/us/app/cozy-cat-hotel-idle-tycoon/id6740759401' }
    }
  },
  {
    id: 'idle-magician-rpg',
    name: 'Idle Magician RPG',
    oneLiner: 'Raise a wizard from zero to legend.',
    status: 'coming-soon',
    art: null,
    screenshots: [],
    platforms: {
      android: { url: null },
      ios: { url: null }
    }
  }
]

export default createStore({
  state: {
    appInfoList: []
  },
  mutations: {
    setGames(state, payload) {
      state.appInfoList = payload
    }
  },
  actions: {
    initInfos({ commit }) {
      commit('setGames', GAMES)
    }
  }
})
